export default {"src":"/_next/static/media/how-it-works-1.4711cf6a.svg","height":223,"width":306,"blurWidth":0,"blurHeight":0};